import {
  Directive,
  EventEmitter,
  HostBinding,
  HostListener,
  Output,
} from '@angular/core';

enum DropColor {
  Default = 'transparent', // Default color
  Over = '#C6E4F1', // Color to be used once the file is "over" the drop box
}

@Directive({
  standalone: true,
  selector: '[appFileDrop]',
})
export class FileDropDirective {
  @Output() dropFile: EventEmitter<File> = new EventEmitter();
  @HostBinding('style.background') backgroundColor = DropColor.Default;

  @HostListener('dragover', [ '$event' ])
  dragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.backgroundColor = DropColor.Over;
  }

  @HostListener('dragleave', [ '$event' ])
  dragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.backgroundColor = DropColor.Default;
  }

  @HostListener('drop', [ '$event' ])
  drop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.backgroundColor = DropColor.Default;

    const fileList = event.dataTransfer?.files;

    if (!fileList) {
      return;
    }

    const file = fileList[0];
    if (file) {
      this.dropFile.emit(file);
    }
  }
}
